import {Component, OnInit} from '@angular/core';

import {UserService} from './core';
import {environment} from '../environments/environment';
import {TranslateService} from '@ngx-translate/core';
import {ActivatedRoute, NavigationEnd, NavigationStart, Router} from '@angular/router';
import {TitleService} from '@common-lib';
import {ToasterConfig} from 'angular2-toaster';
import { Title } from '@angular/platform-browser';
import {map} from 'rxjs/operators/map';
import {filter, mergeMap} from "rxjs/operators";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {

    public toasterConfig: ToasterConfig =
        new ToasterConfig({
            showCloseButton: false,
            tapToDismiss: false,
            timeout: 5000,
            positionClass: 'toast-bottom-right'
        });

    constructor(
        private userService: UserService,
        private translateService: TranslateService,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private titleService: TitleService,
        private coreService: Title
    ) {
    }

    ngOnInit() {
        this.translateService.setDefaultLang(environment.DEFAULT_LANGUAGE);
        this.userService.populate();

        this.router.events
            .pipe(filter((event) => event instanceof NavigationEnd))
            .pipe(map(() => this.activatedRoute))
            .pipe(map((route) => {
                while (route.firstChild) route = route.firstChild;
                return route;
            }))
            .pipe(filter((route) => route.outlet === 'primary'))
            .pipe(mergeMap((route) => route.data))
            .subscribe((event) => {

                if(event['title'].indexOf('edit') === -1) {
                    this.translateService.get(event['title']).toPromise().then(title => {
                        this.coreService.setTitle(title);
                        this.titleService.setTitle(title);
                    });
                }
              });

        /*
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationStart) {
                this.titleService.setTitle('');
            }
        });

        this.activatedRoute.data.subscribe((data) => {
            if (data && data.title) {
                this.titleService.setTitle(data.title);
            }
        });
        */
    }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts